import { Component, ReactNode } from "react";
import { Handle, NodeProps, Position } from "reactflow";
import Styles from "./InfraNode.module.css";
import { Link } from "react-router-dom";

export enum InfraNodeStatus
{
    Online = "Online",
    NotOnline = "Not Online",
    NeverConnected = "Never Connected",
}

export interface InfraNodeProps
{
    label: string;
    image: string;
    type: "Infrastructure" | "Service";
    link: string;
    status?: { title: InfraNodeStatus, color: string};
    meta?: { title: string, value: string | null }[]
}

class InfraNode extends Component<NodeProps<InfraNodeProps>>
{
    override render(): ReactNode
    {
        let props = this.props.data;

        const status_background: Record<string, string> = {
            green: "#b8f5c4",
            red: "#fde8e8",
            gray: "#e2e4e8",
        };
        let background = props.status ? status_background[props.status.color] : undefined;

        return (
            <Link to={props.link} target="_blank" style={{ textDecoration: "none" }}>
                <div className={Styles.node_wrapper} style={background ? { backgroundColor: background } : undefined}>
                    <img
                        src={props?.image}
                        alt="Node"
                        width={48}
                        height={48}
                        className={Styles.node_img}
                    />
                    <span className={Styles.node_label}>
                        {props?.label}
                    </span>
                    {
                        props.status &&
                        <div
                            className={Styles.node_status}
                            style={{ background: props.status.color }}
                            title={props.status.title}
                        />
                    }
                    {
                        props?.type === "Infrastructure" &&
                        <Handle type="source" position={Position.Bottom} isConnectable={false} />
                    }
                    {
                        props?.type === "Service" &&
                        <Handle type="target" position={Position.Top} isConnectable={false} />
                    }
                    {
                        props.meta &&
                        <div className={Styles.node_meta}>
                            {
                                props.meta.map((item) => (
                                    <div className="d-flex flex-wrap justify-content-between gap-y-1 text-dark">
                                        <span>{item.title}:</span>
                                        <span>{item.value}</span>
                                    </div>
                                ))
                            }
                        </div>
                    }
                </div>
            </Link>
        );
    }
}

export default InfraNode;